import { z } from "zod";

export const WithSpanId = <T extends z.ZodRawShape>(s: z.ZodObject<T>) =>
  s.extend({ spanId: z.string().optional() });

export type WithSpanId<T> = T & { spanId?: string };
